import React, { useEffect, useState } from 'react'
import Navbar from '../../components/navbar'

import SME from '../../static/images/expertise/water-tap1.jpg'
import Ach from '../../static/js/achievements'
import Media from '../../static/js/media'

const Achievements = () => {
  const ach = Ach

  const renderAch = ach.map((ach, key) => {
    return (
      <div className='col-lg-4 col-md-6 ach-card'>
        <div>
          <img src={ach.image} />
          <div className='year'>{ach.year}</div>
          <div className='head'>{ach.title}</div>
        </div>
        <div className='org'>{ach.organisation}</div>
      </div>
    )
  })

  const renderMedia = Media.map((media, key) => {
    return (
      <div className='col-lg-4 col-md-6 ach-card'>
        <div>
          <img src={media.image} />
          <div className='year'>{media.year}</div>
          <div className='head'>{media.title}</div>
        </div>
        <div className='org'>{media.organisation}</div>
      </div>
    )
  })

  return (
    <div className='section-nav achievements'>
      <Navbar />
      <div className='ach'>
        <div className='container'>
          <div className='heading'>Accolades</div>
          <div className='row'>{renderAch}</div>
        </div>
      </div>
      <div className='media'>
        <div className='container '>
          <div className='heading-inverse'>Media Coverage</div>
          <div className='row'>{renderMedia}</div>
        </div>
      </div>
    </div>
  )
}

export default Achievements
